import { useEffect, useState } from 'react';
import { ProjectApi, ToastStateHandler } from '../../../api';
import { useContainer } from '../../useContainer';
import { useTranslation } from '../../useTranslation';
import { ProjectDtoRelV2 } from '../../../commonTypes/project.types';

const useHttpGetProjectsByRoleOMX = () => {
    const projectApi: ProjectApi = useContainer(ProjectApi);
    const toastHandler = useContainer(ToastStateHandler);
    const [isReady, setIsReady] = useState(false);
    const [projects, setProjects] = useState<ProjectDtoRelV2[]>([]);
    const { t } = useTranslation('newNotifications');

    useEffect(() => {
        const { exec, abort } = projectApi.getProjectsByRole({
            onSuccess: res => {
                setProjects(res.body);
            },
            onError: _ => toastHandler.push('error', t('common.error'), t('common.somethingWentWrong')),
            onFinally: () => setIsReady(true),
        });
        exec();
        return abort;
    }, []);

    return { isReady, projects, setProjects };
};

export default useHttpGetProjectsByRoleOMX;
